// ---------------------------------------------------------------------------
// Session helpers shared by the chat adapter and the conversation provider.
// ---------------------------------------------------------------------------

// The first turn of a fresh session may have to set up its sandbox, so as soon
// as the panel opens we ask the backend to get it ready while the user is still
// typing. POST /copilot/session only schedules it (202, no LLM turn, nothing
// added to the conversation), so it never has to be awaited and can't race the
// first real message.
const WARMUP_TIMEOUT_MS = 15_000;

export function buildCopilotHeaders(sessionId) {
  const token = localStorage.getItem('token');
  const workspaceId = localStorage.getItem('workspace_id');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  if (workspaceId) headers['workspace-id'] = workspaceId;
  if (sessionId) headers['X-Session-ID'] = sessionId;
  return headers;
}

const HISTORY_TIMEOUT_MS = 15_000;

/** The chat as Copilot holds it: `{session_id, messages: [{role, text}]}`, or null when it cannot be read. */
export async function fetchCopilotHistory(sessionId) {
  try {
    const response = await fetch('/API/v2/copilot/history', {
      method: 'GET',
      headers: buildCopilotHeaders(sessionId),
      signal: AbortSignal.timeout(HISTORY_TIMEOUT_MS),
    });
    return response.ok ? await response.json() : null;
  } catch {
    // Best effort: the snapshot this tab already has is shown either way.
    return null;
  }
}

export function startSessionWarmup(narrativeId, sessionId) {
  fetch('/API/v2/copilot/session', {
    method: 'POST',
    headers: buildCopilotHeaders(sessionId),
    // No case on screen: the key is left out and Copilot warms up a case-less session.
    body: JSON.stringify(narrativeId ? { narrative_id: narrativeId } : {}),
    signal: AbortSignal.timeout(WARMUP_TIMEOUT_MS),
  }).catch(() => {
    // Warm-up is best-effort: a failure just means the first real message
    // pays the cold-start cost, exactly as before.
  });
}
